/**
 * @generated SignedSource<<bc6bc3f26198296f4e9eb467b85083ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type registerAliveMutation$variables = {
  clientTime?: string | null;
  latency?: number | null;
  screenHeight?: number | null;
  screenId: string;
  screenScale?: number | null;
  screenWidth?: number | null;
  timeZone?: string | null;
};
export type registerAliveMutation$data = {
  readonly storecast: {
    readonly registerAliveDevice: boolean;
  };
};
export type registerAliveMutation = {
  response: registerAliveMutation$data;
  variables: registerAliveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clientTime"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "latency"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenHeight"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenScale"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenWidth"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeZone"
},
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorecastMutation",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "clientTime",
            "variableName": "clientTime"
          },
          {
            "kind": "Variable",
            "name": "latency",
            "variableName": "latency"
          },
          {
            "kind": "Variable",
            "name": "screenHeight",
            "variableName": "screenHeight"
          },
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "screenId"
          },
          {
            "kind": "Variable",
            "name": "screenScale",
            "variableName": "screenScale"
          },
          {
            "kind": "Variable",
            "name": "screenWidth",
            "variableName": "screenWidth"
          },
          {
            "kind": "Variable",
            "name": "timeZone",
            "variableName": "timeZone"
          }
        ],
        "kind": "ScalarField",
        "name": "registerAliveDevice",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "registerAliveMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "registerAliveMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "5b4a604c7c174aa1315f197fa2cbaab2",
    "id": null,
    "metadata": {},
    "name": "registerAliveMutation",
    "operationKind": "mutation",
    "text": "mutation registerAliveMutation(\n  $screenId: ID!\n  $latency: Int\n  $screenWidth: Int\n  $screenHeight: Int\n  $screenScale: Float\n  $timeZone: String\n  $clientTime: String\n) {\n  storecast {\n    registerAliveDevice(screenId: $screenId, latency: $latency, screenWidth: $screenWidth, screenHeight: $screenHeight, screenScale: $screenScale, timeZone: $timeZone, clientTime: $clientTime)\n  }\n}\n"
  }
};
})();

(node as any).hash = "3968c908c7ab757e5e1963566130e6b8";

export default node;
